module.exports = __webpack_public_path__ + "img/Blizzert_ticket.b688b23c.png";